import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/delete',
    method: 'post',
    data: data
  });
}